//
// イニシャルステートの初期化
export const initialState = {
    saleItems: {},
    columnItems: {},
    latestItems: {},
    headerProps: {},
    saleOrder: [],
    scrollStatus: {}
};
export const saleItemsReducer = (state, action) => {
    switch (action.type) {
        case 'setSaleItems':
            return {
                ...state, saleItems: action.value
            };
        case 'setLatestItems':
            return {
                ...state, latestItems: action.value
            };
        case 'setColumnItems':
            return {
                ...state, columnItems: action.value
            };
        case 'setHeaderProps':
            return {
                ...state, headerProps: action.value
            };
        case 'setSaleOrder':
            return {
                ...state, saleOrder: action.value
            };
        case 'setScrollStatus':
            return {
                ...state, scrollStatus: action.value
            };
        default:
            return state;
    }
};
